import { create } from "zustand";
import { useGifStore } from "./gifStore";

interface ILikesStore {
  likes: string[];
  isFetched: boolean;
  isLoading: boolean;
  setLikes: (likes: string[]) => void;
  setLike: (gifId: string) => void;
  setUnLike: (gifId: string) => void;
  checkLiked: (gifId: string) => boolean;
  setFetched: (isFetched: boolean) => void;
  setLoading: (isLoading: boolean) => void;
}

const updateGifLikes = (gifId: string, increment: boolean) => {
  useGifStore.setState((state) => ({
    gifs: state.gifs.map((gif) =>
      gif.id === gifId
        ? { ...gif, likes: Math.max(0, (gif.likes || 0) + (increment ? 1 : -1)) }
        : gif
    ),
  }));
};

export const useLikesStore = create<ILikesStore>(
  (set, get) => ({
    likes: [],
    isFetched: false,
    isLoading: false,
    setLikes: (likes: string[]) => set(() => ({ likes })),
    checkLiked: (gifId: string) => get().likes.includes(gifId),
    setLoading: (isLoading: boolean) => set(() => ({ isLoading })),
    setFetched: (isFetched: boolean) => set(() => ({ isFetched })),
    setLike: (gifId: string) => set((state) => {
      if (!state.likes.includes(gifId)) {
        updateGifLikes(gifId, true);
        return { likes: [...state.likes, gifId] };
      }
      return state;
    }),
    setUnLike: (gifId: string) => set((state) => {
      if (state.likes.includes(gifId)) {
        updateGifLikes(gifId, false);
        return { likes: state.likes.filter((id) => id !== gifId) };
      }
      return state;
    }),
  }),
);
